module.exports = __webpack_public_path__ + "media/icons/pencil-63d8558c.svg";